import React from "react";
import Colorer from "color";
import styled, { css, ThemeProvider } from "styled-components";
import {
  CssImage,
  CSSproductDesc,
  CssPrice,
  CssPaper,
  CssPopSection,
  CssFormGroup,
  Button,
  CssContentBlock,
} from "../uikit-b2c/uikit-b2c";

export const PStotal = ({ show = ["cart", "vat", "fee", "grand"], theme }) => {
  return (
    <ThemeProvider theme={theme}>
      <ul
        id="cart_total"
        style={{
          // fontSize: 13,
          margin: 0,
          padding: 0,
          width: "100%",
        }}
      >
        {show.indexOf("cart") !== -1 && (
          <CSSli>
            <div>
              <div>3 items</div>
            </div>
            <CssPriceTotal0>
              <CssPrice>
                <div>$29.81</div>
              </CssPrice>
            </CssPriceTotal0>
        </CSSli>
        )}

        {show.indexOf("vat") !== -1 && (
          <CSSli>
            <div>
              <div>VAT (10%)</div>
            </div>
            <CssPriceTotal0>
              <CssPrice>
                <div>$3.49</div>
              </CssPrice>
            </CssPriceTotal0>
          </CSSli>
        )}

        {show.indexOf("fee") !== -1 && (
          <CSSli>
            <div>
              <div>Payment System Fee</div>
            </div>
            <CssPriceTotal0>
              <CssPrice>
                <div>$1.88</div>
              </CssPrice>
            </CssPriceTotal0>
          </CSSli>
        )}

        {show.indexOf("grand") !== -1 && (
          <CSSli>
            <div>
              <b>Grand Total</b>
            </div>
            <CssPriceTotal0>
              <CssPrice size="lg">$34.99</CssPrice>
            </CssPriceTotal0>
          </CSSli>
        )}
      </ul>
    </ThemeProvider>
  );
};

const CSSli = styled.li`
  padding: 0px 0px 8px 0px;
  margin: 0 0 8px 0;
  border-bottom: 1px solid
    ${({ theme }) =>
      Colorer(theme["colorText"])
        .alpha(0.1)
        .string()};
  color: 1px solid
    ${({ theme }) =>
      Colorer(theme["colorText"])
        .alpha(0.2)
        .string()};
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-column-gap: 16px;
  &:last-child {
    border-bottom: none;
  }
`;

const CssPriceTotal0 = styled.div``;
